




























import { defineComponent, useRoute, computed } from '@nuxtjs/composition-api';
import urlJoin from 'url-join';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';

export default defineComponent({
  components: {
    AppImage,
    AppIcon,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  setup() {
    const route = useRoute();
    const { FRONTEND_ORIGIN } = useRuntimeConfig();

    const fullUrl = computed(() => {
      return urlJoin(FRONTEND_ORIGIN, route.value.fullPath);
    });

    //  FaceBookのリンク
    const faceBookLink = computed(() => {
      return `https://www.facebook.com/sharer/sharer.php?u=${fullUrl.value}`;
    });
    // Twitterのリンク
    const twitterLink = computed(() => {
      return `https://twitter.com/intent/tweet?url=${fullUrl.value}`;
    });

    return { faceBookLink, twitterLink };
  },
});
